import { GroupMembershipResponse } from '../../../React/Common/Types/Types'
import { AgentResponse, DeviceResponse } from '../../Types/Types'
import { ArrayUtils } from '../../utils/ArrayUtils'

/**
 * Reduces multiple GroupMembershipResponse objects into a single one by concatenating their ACDAgents and Devices arrays.
 *
 * @param responses - An array of GroupMembershipResponse objects to be reduced.
 * @returns A single GroupMembershipResponse object containing concatenated ACDAgents and Devices.
 */
export const reduceGroupMemberships = (
    responses: Nullable<GroupMembershipResponse>[]
): Nullable<GroupMembershipResponse> =>
    responses?.reduce(
        (
            accum: Nullable<GroupMembershipResponse>,
            next: Nullable<GroupMembershipResponse>
        ): GroupMembershipResponse => ({
            ACDAgents: ArrayUtils.sortAlphabeticalByField(
                ArrayUtils.removeDuplicatesByKey(
                    [...(accum?.ACDAgents ?? []), ...(next?.ACDAgents ?? [])],
                    (a: AgentResponse) => a.AgentNumber
                ),
                (a: AgentResponse) => a.AgentNumber
            ),
            Devices: ArrayUtils.sortAlphabeticalByField(
                ArrayUtils.removeDuplicatesByKey(
                    [...(accum?.Devices ?? []), ...(next?.Devices ?? [])],
                    (d: DeviceResponse) => d.DeviceNumber
                ),
                (d: DeviceResponse) => d.DeviceNumber
            )
        })
    )
